(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vivac-product-gallery-controls"] && !Shopify.designMode) return;
  try {
    if (!window.vivacProductGalleryNavigationReady) {
    window.vivacProductGalleryNavigationReady = true;

    document.addEventListener('click', (event) => {
      const navigationButton = event.target.closest(
        '[data-vivac-gallery-previous], [data-vivac-gallery-next]'
      );

      if (!navigationButton) return;

      const gallery = navigationButton.closest('media-gallery');
      if (!gallery) return;

      const allThumbnails = Array.from(gallery.querySelectorAll('.thumbnail-list .thumbnail'));
      const visibleThumbnails = allThumbnails.filter((thumbnail) => {
        const item = thumbnail.closest('.thumbnail-list__item');
        return item && item.offsetParent !== null;
      });
      const thumbnails = visibleThumbnails.length > 0 ? visibleThumbnails : allThumbnails;

      if (thumbnails.length < 2) return;

      let activeIndex = thumbnails.findIndex(
        (thumbnail) => thumbnail.getAttribute('aria-current') === 'true'
      );
      if (activeIndex < 0) activeIndex = 0;

      const direction = navigationButton.hasAttribute('data-vivac-gallery-next') ? 1 : -1;
      const targetIndex = (activeIndex + direction + thumbnails.length) % thumbnails.length;
      thumbnails[targetIndex].click();
      thumbnails[targetIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
